// Third-party
import React from 'react';

// Components
import { FormattedMessage } from '../../../../../utils/i18n';
import { SecondaryButton } from '../../../../../views/components/buttons';
import { Typography } from '@capintel/component-lib/typography';
import { ALLOWED_HTML_TAGS } from '@/views/components/i18n/FormattedMessageV2';

type Props = {
  onChangeTemplate?: () => void;
};

const ProposalTemplateSelector: React.FunctionComponent<Props> = ({ onChangeTemplate, ...rest }: Props) => (
  <div className="proposal-option">
    <Typography as={ALLOWED_HTML_TAGS.H2} variant="headerXs">
      <FormattedMessage id="Proposal.Tabs.Options.Template" />
    </Typography>
    <SecondaryButton className="reselect-template" compact onClick={onChangeTemplate}>
      <FormattedMessage id="Proposal.Tabs.Options.ReselectTemplate" />
    </SecondaryButton>
  </div>
);

export default ProposalTemplateSelector;
